import { DataService } from './DataService';

export class DashboardService extends DataService {
    public static async getDashboardAsync(year: number) {
        return await this.client.getDashboard(year);
    }
}
